import {
    ON_SET
} from '../Actions/PreferredClickCollectAddress.action';

const DEFAULT_STATE = {
    selectedClickCollectAddress:JSON.parse(window.localStorage.getItem("preferredclickcollectaddress")??"{}")
};

export const preferredClickCollectAddress = (state = DEFAULT_STATE, action) => {
    const { type, payload } = action;
    switch (type) {     
        case ON_SET:
            if(payload.value)
            {
                window.localStorage.setItem("preferredclickcollectaddress", JSON.stringify(payload.value));
                return {                
                    selectedClickCollectAddress:payload.value,
                };
            }else{
                window.localStorage.removeItem("preferredclickcollectaddress");
                return {                
                    selectedClickCollectAddress:{},
                };
            }
              
        default:
            return state;
    }
};
